(() => {
  function mount(root) {
    if (root.dataset.catalogReady) return;
    root.dataset.catalogReady = 'true';
    const grid = root.querySelector('[data-catalog-grid]');
    if (!grid) return;
    const search = root.querySelector('[data-catalog-search]');
    const sort = root.querySelector('[data-catalog-sort]');
    const more = root.querySelector('[data-catalog-more]');
    const status = root.querySelector('[data-catalog-status]');
    const nativePages = root.querySelector('[data-catalog-native-pagination]');
    const tabs = root.querySelector('[data-outfit-tabs]');
    let pieces = tabs ? new URL(location.href).searchParams.get('pieces') || '' : '';
    if (!['', '2', '3', '4', '5', '6'].includes(pieces)) pieces = '';
    const cards = new Map();
    const pageSize = 24;
    const language = document.documentElement.lang.slice(0, 2);
    const words = language === 'es' ? ['Anterior', 'Siguiente', 'Página', 'de'] : language === 'pt' ? ['Anterior', 'Seguinte', 'Página', 'de'] : ['Previous', 'Next', 'Page', 'of'];
    const readPage = () => Math.max(1, parseInt(new URL(location.href).searchParams.get('catalog_page'), 10) || 1);
    let page = readPage();
    const pager = document.createElement('nav');
    pager.className = 'collection-pagination';
    pager.setAttribute('aria-label', words[2]);
    pager.style.cssText = 'display:flex;flex-wrap:wrap;align-items:center;gap:8px;margin:32px 0';
    more.replaceWith(pager);
    const initialURL = new URL(location.href);
    if (search) search.value = initialURL.searchParams.get('catalog_search') || '';
    if (sort && initialURL.searchParams.get('catalog_order') === 'newest') sort.value = 'newest';
    function saveURL(push = false) {
      const url = new URL(location.href);
      const set = (key, value) => value ? url.searchParams.set(key, value) : url.searchParams.delete(key);
      set('catalog_page', page > 1 ? String(page) : '');
      set('catalog_search', search?.value.trim() || '');
      set('catalog_order', sort?.value === 'newest' ? 'newest' : '');
      set('pieces', pieces);
      url.searchParams.delete('page');
      history[push ? 'pushState' : 'replaceState']({}, '', url);
    }
    function showGrid() {
      const header = document.querySelector('.global-nav');
      const sticky = header && getComputedStyle(header).position === 'sticky' ? header.getBoundingClientRect().height : 0;
      grid.setAttribute('tabindex', '-1');
      grid.focus({preventScroll: true});
      window.scrollTo({top: Math.max(0, grid.getBoundingClientRect().top + window.scrollY - sticky - 16), behavior: 'instant'});
    }
    let loading = false;
    let failed = false;
    const collect = node => node.querySelectorAll('[data-catalog-card]').forEach(card => {
      if (!cards.has(card.dataset.productId)) cards.set(card.dataset.productId, card);
    });
    collect(grid);
    function render() {
      const query = (search?.value || '').toLocaleLowerCase().trim();
      const ordered = [...cards.values()].sort((a, b) => {
        const bySize = Number(b.dataset.sizes) - Number(a.dataset.sizes);
        const byDate = Number(b.dataset.created) - Number(a.dataset.created);
        return (sort?.value === 'newest' ? byDate || bySize : bySize || byDate) || Number(b.dataset.productId) - Number(a.dataset.productId);
      });
      tabs?.querySelectorAll('[data-pieces]').forEach(link => link.setAttribute('aria-current', String(link.dataset.pieces === pieces)));
      const matching = ordered.filter(card => (!pieces || card.dataset.pieces === pieces) && (!query || card.textContent.toLocaleLowerCase().includes(query)));
      const totalPages = Math.max(1, Math.ceil(matching.length / pageSize));
      if (!loading) page = Math.min(page, totalPages);
      const visible = new Set(matching.slice((page - 1) * pageSize, page * pageSize));
      const fragment = document.createDocumentFragment();
      for (const card of ordered) {
        card.hidden = !visible.has(card);
        fragment.appendChild(card);
      }
      grid.replaceChildren(fragment);
      pager.replaceChildren();
      pager.hidden = totalPages <= 1;
      pager.style.display = totalPages <= 1 ? 'none' : 'flex';
      const button = (label, target, disabled = false, current = false) => {
        const control = document.createElement('button');
        control.type = 'button';
        control.textContent = label;
        control.dataset.catalogPage = target;
        control.disabled = disabled || loading;
        control.style.cssText = 'min-width:44px;min-height:44px;padding:10px 14px;border:1px solid #d7d3ce;background:#fff;color:#111;cursor:pointer;font:inherit;font-size:13px';
        if (current) { control.setAttribute('aria-current', 'page'); control.style.background = '#111'; control.style.color = '#fff'; }
        if (control.disabled) { control.style.opacity = '.4'; control.style.cursor = 'default'; }
        pager.appendChild(control);
      };
      button(words[0], page - 1, page === 1);
      const numbers = [...new Set([1, ...Array.from({length: 5}, (_, i) => page - 2 + i), totalPages])].filter(n => n >= 1 && n <= totalPages).sort((a,b) => a-b);
      let previous = 0;
      numbers.forEach(n => {
        if (previous && n - previous > 1) { const dots = document.createElement('span'); dots.textContent = '…'; pager.appendChild(dots); }
        button(String(n), n, false, n === page);
        previous = n;
      });
      button(words[1], page + 1, page === totalPages);
      status.textContent = loading ? status.dataset.loading : failed ? status.dataset.failure : matching.length === 0 ? status.dataset.empty : words[2] + ' ' + page + ' ' + words[3] + ' ' + totalPages;

    }
    tabs?.addEventListener('click', event => {
      const link = event.target.closest('[data-pieces]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      pieces = link.dataset.pieces;
      page = 1; saveURL(true); render();
    });
    window.addEventListener('popstate', () => {
      const url = new URL(location.href);
      pieces = tabs ? url.searchParams.get('pieces') || '' : '';
      page = readPage();
      if (search) search.value = url.searchParams.get('catalog_search') || '';
      if (sort) sort.value = url.searchParams.get('catalog_order') === 'newest' ? 'newest' : 'sizes';
      render();
    });
    search?.addEventListener('input', () => { page = 1; saveURL(); render(); });
    sort?.addEventListener('change', () => { page = 1; saveURL(true); render(); });
    pager.addEventListener('click', event => {
      const control = event.target.closest('[data-catalog-page]');
      if (!control || control.disabled) return;
      page = Number(control.dataset.catalogPage);
      saveURL(true);
      render();
      showGrid();
    });
    async function loadAll() {
      let next = grid.dataset.next;
      if (Number(grid.dataset.currentPage) > 1) {
        const first = new URL(window.location.href);
        first.searchParams.set('page', '1');
        next = first.href;
      }
      if (!next) { render(); return; }
      loading = true;
      if (nativePages) nativePages.hidden = true;
      render();
      const visited = new Set();
      try {
        while (next) {
          const url = new URL(next, window.location.href);
          if (url.origin !== window.location.origin) throw new Error('Unexpected collection origin');
          url.searchParams.set('section_id', root.dataset.sectionId);
          if (visited.has(url.href)) throw new Error('Repeated collection page');
          visited.add(url.href);
          const response = await fetch(url, {credentials: 'same-origin', signal: AbortSignal.timeout(15000)});
          if (!response.ok) throw new Error('Collection unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextGrid = doc.querySelector('[data-catalog-grid]');
          if (!nextGrid) throw new Error('Missing collection');
          collect(nextGrid);
          next = nextGrid.dataset.next;
        }
      } catch {
        failed = true;
        if (nativePages) nativePages.hidden = false;
      } finally { loading = false; render(); }
    }
    loadAll();
  }
  document.querySelectorAll('[data-stock-catalog]').forEach(mount);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-stock-catalog]').forEach(mount);
  });
})();
